module.exports = __webpack_public_path__ + "img/IMG-20181201-WA0034.05395f1b.jpg";